export const OWN_AND_CHILD_BRANCHES = 'OWN_AND_CHILD_BRANCHES'
export const OWN_AND_CHILD_BRANCHES_ONE = 'OWN_AND_CHILD_BRANCHES_ONE'
export const OWN_AND_CHILD_USERS = 'OWN_AND_CHILD_USERS'
export const FRANCHISEE_COMPANY = 'FRANCHISEE_COMPANY'
export const REPORT_COMPANY = 'REPORT_COMPANY'
export const FRANCHISEE_BRANCH = 'FRANCHISEE_BRANCH'
export const PARTY_BOOKING_FILTER = 'PARTY_BOOKING_FILTER'
export const ANALYSIS_FILTER = 'ANALYSIS_FILTER'
export const DISPATCH_FILTER = 'DISPATCH_FILTER'
export const BRANCH_TRANSFER = 'BRANCH_TRANSFER'
export const BRANCH_RECEIVE = 'BRANCH_RECEIVE'
export const GST_INVOICE = 'GST_INVOICE'
export const OWN_BOOKING_REPORT_DROP_DATA = `OWN_BOOKING_REPORT_DROP_DATA`
export const OWN_BOOKING_REPORT_DATA = `OWN_BOOKING_REPORT_DATA`
export const GST_REPORT_FILTER_DATA = `GST_REPORT_FILTER_DATA`
export const GST_REPORT_DETAIL_DATA = `GST_REPORT_DETAIL_DATA`
export const GST_REPORT_Summary_DATA = `GST_REPORT_Summary_DATA`
export const DISPATCH_DETAILS = 'DISPATCH_DETAILS'
export const DISPATCH_DETAILS_DATA = 'DISPATCH_DETAILS_DATA'
export const CHALLAN_WISE_DISPATCH_DATA = 'CHALLAN_WISE_DISPATCH_DATA'
export const DISPATCH_SUMMARY_DATA = 'DISPATCH_SUMMARY_DATA'
export const DISPATCH_MEMODETAIL_DATA = 'DISPATCH_MEMODETAIL_DATA'
export const USER_WISE_COLLECTION = 'USER_WISE_COLLECTION'
export const BRANCH_LIST_CONFIG = 'BRANCH_LIST_CONFIG'
export const FRANCHISEE_TO_OWN = 'FRANCHISEE_TO_OWN'
export const BOOKING_FILTER_DATA = 'BOOKING_FILTER_DATA'
export const ANALYSIS_TABLE_DATA = 'ANALYSIS_TABLE_DATA'
export const CARGO_SETTING_FILTER = 'CARGO_SETTING_FILTER'
export const PARTY_BOOKING_DATA = 'PARTY_BOOKING_DATA'
export const RECEIVED_DROP_DATA = 'RECEIVED_DROP_DATA'
export const RECEIVED_TABLE_DATA = 'RECEIVED_TABLE_DATA'
export const ON_ACCOUNT_REPORT_DATA = `ON_ACCOUNT_REPORT_DATA`
export const BOOKING_FRANCHISEE_DATA = 'BOOKING_FRANCHISEE_DATA'
export const QUIKVIEW_TABLE_DATA = 'QUIKVIEW_TABLE_DATA'
export const EWAY_BOOKING_FILTER = 'EWAY_BOOKING_FILTER'
export const EWAY_BOOKING_DATA = 'EWAY_BOOKING_DATA'
export const GOODBAL_DROP_DATA = 'GOODBAL_DROP_DATA'
export const GOODBAL_TABLE_DATA = 'GOODBAL_TABLE_DATA'
export const BRANCHSTOCK_TABLE_DATA = 'BRANCHSTOCK_TABLE_DATA'
export const FRANCHISE_OUTSTANDING_TABLE_DATA = 'FRANCHISE_OUTSTANDING_TABLE_DATA'
export const FRANCHISE_OUTSTANDING_TABLE_FILTER_DATA = 'FRANCHISE_OUTSTANDING_TABLE_FILTER_DATA'
export const TO_PAY_DESTINATION_REPORT_TABLE_DATA= 'TO_PAY_DESTINATION_REPORT_TABLE_DATA'
export const REPORT_BRANCH_LIST = 'REPORT_BRANCH_LIST'
export const CREDIT_TRANSACTION_DATA = 'CREDIT_TRANSACTION_DATA'
export const CREDIT_Usage_DATA = 'CREDIT_Usage_DATA'
export const CREDIT_SUMMARY_DATA = 'CREDIT_SUMMARY_DATA'
export const TRACKING_REPORT_FILTER = 'TRACKING_REPORT_FILTER'
export const TRACKING_REPORT_DATA = 'TRACKING_REPORT_DATA'
export const USER_WISE_COLLECTION_WITH_DELIVERY_EXPENSE = 'USER_WISE_COLLECTION_WITH_DELIVERY_EXPENSE'

export const DELIVERY_FILTER_DATA = 'DELIVERY_FILTER_DATA'
export const DELIVERY_TABLE_DATA = 'DELIVERY_TABLE_DATA'
export const LR_CANCEL_AND_PENALTY_REPORT_FILTER_DATA = 'LR_CANCEL_AND_PENALTY_REPORT_FILTER_DATA'
export const LR_CANCEL_AND_PENALTY_REPORT_TABLE_DATA = 'LR_CANCEL_AND_PENALTY_REPORT_TABLE_DATA'
export const CARGO_UNLOADING_TABLE_DATA = 'CARGO_UNLOADING_TABLE_DATA'
export const DISP_VEHICLENO_DATA = 'DISP_VEHICLENO_DATA'
export const PARTY_CREDIT_Usage_DATA = 'PARTY_CREDIT_Usage_DATA'
export const USER_WIth_TRANS_RIGHT_REPORT_TABLE_DATA = 'USER_WIth_TRANS_RIGHT_REPORT_TABLE_DATA'
export const RECHAGE_PENALTY_REPORT_TABLE_DATA = 'RECHAGE_PENALTY_REPORT_TABLE_DATA'  
export const PARTY_TARGET_ACHIVEMENT_REPORT_TABLE_DATA = 'PARTY_TARGET_ACHIVEMENT_REPORT_TABLE_DATA'
export const RECEIPT_RESITER_FILTER = 'RECEIPT_RESITER_FILTER'
export const RECEIPT_REGISTER_REPORT_TABLE_DATA = 'RECEIPT_REGISTER_REPORT_TABLE_DATA'
export const PENALTY_TARGET_ACHIVEMENT_REPORT_FILTER_DATA = 'PENALTY_TARGET_ACHIVEMENT_REPORT_FILTER_DATA'
export const PARTY_CREDIT_TRANSACTION_DATA = 'PARTY_CREDIT_TRANSACTION_DATA'
export const PARTY_CREDIT_LIMIT_SUMMARY_DATA = 'PARTY_CREDIT_LIMIT_SUMMARY_DATA'
export const LUGGAGE_MODIFICATION_REPORT = 'LUGGAGE_MODIFICATION_REPORT'
export const LR_DETAILS_FOR_POPUP_V2  = 'LR_DETAILS_FOR_POPUP_V2'
export const GET_CARGO_SETTING = 'GET_CARGO_SETTING'
export const REPORT_COMPANYV2 = 'REPORT_COMPANYV2'
export const FRANCHISEE_COMPANYV2 = 'FRANCHISEE_COMPANYV2'
export const DISPATCH_RESITER_FILTER = 'DISPATCH_RESITER_FILTER'
export const DISPATCH_RESITER_TABLE_DATA = 'DISPATCH_RESITER_TABLE_DATA'
export const DISPATCH_RESITER_TABLE_VEHICLE_WISE_DATA = 'DISPATCH_RESITER_TABLE_VEHICLE_WISE_DATA'
export const DISPATCH_RESITER_MEMO_TABLE = 'DISPATCH_RESITER_MEMO_TABLE'
export const TO_PAY_STATEMENT_REPORT = 'TO_PAY_STATEMENT_REPORT'
export const MPESA_TRANSACTION_REPORT = 'MPESA_TRANSACTION_REPORT'
export const BRANCH_STOCK_FILTER_DATA = 'BRANCH_STOCK_FILTER_DATA'
